import * as yup from 'yup';

import { requiredSelectField, requiredStringField } from '@blockpulse3/web-client/forms';

import { IAddressForm } from './types';

export const schema = yup
  .object({
    line: requiredStringField,
    city: requiredStringField,
    postalCode: requiredStringField,
    country: requiredSelectField,
  })
  .required();

export const addressFormDefaultValues: IAddressForm = {
  line: '',
  city: '',
  postalCode: '',
  country: { label: '', value: '' },
};
